export default {
  apiRoot: '/api/v1',
  apiDirect: process.env.NODE_ENV === 'production' ? 'https://reservble.com' : 'http://localhost:3011',
};
